import { ElementRef } from '@angular/core';

// This function takes a blob type with an identifier and makes a file download happen in the browser
export function downloadFile(anchor: ElementRef, file: Blob, id: string, mimeType: string): void {
  // Based off this article: https://www.illucit.com/en/angular/angular-5-httpclient-file-download-with-authentication/
  const url = window.URL.createObjectURL(new Blob([file], { type: mimeType }));
  const link = anchor.nativeElement;
  link.href = url;
  link.download = id;
  link.click();
  window.URL.revokeObjectURL(url);
}

export function viewFile(file: Blob, mimeType: string): void {
  const url = window.URL.createObjectURL(new Blob([file], { type: mimeType }));
  window.open(url, '_blank');
}
